import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'
import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	getAvailableAggregateCards: {
		useCache: true, //кешируемый флаг
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.AGGREGATE_CARDS].GET_AVAILABLE_AGGREGATE_CARDS,
	},
	getBasedAggregateCards: {
		useCache: true,
		cacheStorage: STORE_MAP.BASE,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.AGGREGATE_CARDS].GET_AVAILABLE_AGGREGATE_CARDS,
	},
	getExtendedAggregateCards: {
		useCache: true,
		cacheStorage: STORE_MAP.EXTENDED,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.AGGREGATE_CARDS].GET_AVAILABLE_AGGREGATE_CARDS,
	},
	getFullAggregateCards: {
		useCache: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.AGGREGATE_CARDS].GET_AVAILABLE_AGGREGATE_CARDS,
	},
}
